import React from "react";
import Dashboard from "./Dashboard";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Scope2Layout from "../../../Layout/Scope2Layout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
const Scope2Dashboard = () => {
  const{user}=useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope2Layout />}>
      <Unauthorized requiredModule="Environment | Scope 2">
        <Dashboard />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Scope2Dashboard;
